import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};

const CardHeader = ({ children }: Props) => {
  return <div styleName="card-header">{children}</div>;
};

export default CardHeader;
